module.exports = __webpack_public_path__ + "images/emoji/snowboarder.383705b3e2dc80e116f3.png";